import { fromNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableModel } from '../../models/ValuableModel'

export class SchemaURLSearchParamsModel extends ValuableModel {
  @fromNode()
  @reactive('deep')
  entries?: string[][]
}

declare global {
  export interface RehajeViewModels {
    'Schema.URLSearchParams': SchemaURLSearchParamsModel
  }
}
